import { FingerprintProvider } from './visitor-providers/fingerprint-provider';
import { VisitorGeneric } from './visitor-providers/visitor-generic';

const fingerprintProvider = new FingerprintProvider();
export const visitorInstance = VisitorGeneric.getInstance(fingerprintProvider);
